export default __webpack_public_path__ + "static/media/red-shocks.a49dacb5.svg";